/**
 * Normalizes model HTML so ReactQuill is less likely to throw or show broken content.
 */

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

/**
 * @param {string} html
 * @returns {string} HTML fragment for Quill
 */
export function sanitizeHtmlForQuill(html) {
  if (!html || typeof html !== "string") return "<p><br></p>";
  const trimmed = html.trim();
  if (!trimmed) return "<p><br></p>";

  try {
    const doc = new DOMParser().parseFromString(
      `<div id="q-sanitize">${trimmed}</div>`,
      "text/html"
    );
    const root = doc.getElementById("q-sanitize");
    if (!root) return `<p>${escapeHtml(trimmed)}</p>`;

    root.querySelectorAll("script,style,iframe,object,embed,noscript").forEach((n) =>
      n.remove()
    );

    root.querySelectorAll("h3,h4,h5,h6").forEach((el) => {
      const h2 = doc.createElement("h2");
      h2.innerHTML = el.innerHTML;
      el.replaceWith(h2);
    });

    root.querySelectorAll("table").forEach((t) => {
      const p = doc.createElement("p");
      p.textContent = t.textContent.replace(/\s+/g, " ").trim();
      t.replaceWith(p);
    });

    const unwrapTags = [
      "DIV",
      "SECTION",
      "ARTICLE",
      "MAIN",
      "HEADER",
      "FOOTER",
      "CENTER",
      "FONT",
      "SPAN",
    ];
    let guard = 0;
    while (guard++ < 50) {
      const found = Array.from(root.getElementsByTagName("*")).find((el) =>
        unwrapTags.includes(el.tagName)
      );
      if (!found) break;
      const parent = found.parentNode;
      if (!parent) break;
      while (found.firstChild) {
        parent.insertBefore(found.firstChild, found);
      }
      parent.removeChild(found);
    }

    root.querySelectorAll("a").forEach((a) => {
      const href = a.getAttribute("href");
      if (href && !/^https?:\/\//i.test(href) && !href.startsWith("mailto:")) {
        a.removeAttribute("href");
      }
      a.removeAttribute("onclick");
    });

    let inner = root.innerHTML.trim();
    if (!inner) return "<p><br></p>";

    const probe = doc.createElement("div");
    probe.innerHTML = inner;
    if (!probe.textContent.trim()) return "<p><br></p>";

    return inner;
  } catch {
    return `<p>${escapeHtml(trimmed)}</p>`;
  }
}
